const Conditional = props => !!props.if && props.children;

export default Conditional;



// WEBPACK FOOTER //
// ./src/commonComponents/Conditional/Conditional.js